var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mx-4" },
    [
      _c(
        "validation-observer",
        {
          ref: "paymentRelationshipForm",
          attrs: { novalidate: "", tag: "form" }
        },
        [
          _c("div", { staticClass: "row mb-3 pt-3" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("icon-view", {
                  attrs: {
                    icon: "fa fa-user-edit",
                    "icon-background": "#fff",
                    "icon-color": "#FF7058",
                    "icon-size": "15px",
                    title: "Búsqueda de Relación de Pago",
                    variant: "custom-icon-view"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-3 col-sm-12" },
              [
                _c("custom-drop-down", {
                  staticClass: "custom-drop-down relation-field",
                  attrs: {
                    clearable: false,
                    fieldkey: "id",
                    fieldname: "name",
                    options: _vm.relationTypes,
                    placeholder: "Seleccione"
                  },
                  model: {
                    value: _vm.filter.reasonType,
                    callback: function($$v) {
                      _vm.$set(_vm.filter, "reasonType", $$v)
                    },
                    expression: "filter.reasonType"
                  }
                })
              ],
              1
            ),
            _vm.showFilter
              ? _c(
                  "div",
                  { staticClass: "col-md-3 col-sm-12 mt-2 mt-md-0 mt-sm-2" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  staticClass: "w-100 sie-field",
                                  attrs: {
                                    "custom-error-msg":
                                      "Debe Escribir Número de SIE o SSN",
                                    error: errors[0],
                                    icon: "fa fa-search color-orange",
                                    "left-icon": "",
                                    placeholder: "Escribir Número de SIE o SSN"
                                  },
                                  model: {
                                    value: _vm.filter.sieOrSsn,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "sieOrSsn", $$v)
                                    },
                                    expression: "filter.sieOrSsn"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        5551040
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass:
                  "col-md-3 col-sm-12 mt-2 mt-md-0 mt-sm-2 d-flex align-items-start justify-content-md-start justify-content-sm-end"
              },
              [
                _c(
                  "action-button",
                  {
                    attrs: { i: "fa fa-search", variant: "success px-3" },
                    on: { click: _vm.searchHandler }
                  },
                  [_vm._v(" Buscar ")]
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row mt-4" }, [
            _c(
              "div",
              { staticClass: "col-12 pb-5" },
              [
                _vm.result.studentInfo && _vm.result.services.length > 0
                  ? _c("board", {
                      staticClass: "my-4",
                      attrs: { details: _vm.studentBoardData }
                    })
                  : _vm._e(),
                _c("custom-separator", {
                  staticClass: "my-5",
                  attrs: { text: "Resultado de Búsqueda" }
                }),
                _vm.result.services.length === 0
                  ? _c("custom-result-not-found")
                  : _vm._e(),
                _vm.result.services.length > 0
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.result.services, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: `item-service-${index}`,
                              staticClass: "col-3 mb-3"
                            },
                            [
                              _c("custom-checkbox-single-option", {
                                ref: "customCheckboxRef",
                                refInFor: true,
                                staticClass: "custom-single-option",
                                attrs: {
                                  "option-text": _vm.serviceDescription(
                                    item.serviceDescription
                                  )
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.onSelectServiceHandler(
                                      item,
                                      index
                                    )
                                  }
                                },
                                model: {
                                  value: item.selected,
                                  callback: function($$v) {
                                    _vm.$set(item, "selected", $$v)
                                  },
                                  expression: "item.selected"
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _c(
                        "div",
                        { staticClass: "row mt-4 mt-md-0 mt-sm-3 pb-3" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 d-flex align-items-center justify-content-md-end justify-content-sm-none"
                            },
                            [
                              _c(
                                "action-button",
                                {
                                  attrs: {
                                    i: "fas fa-times-circle",
                                    variant:
                                      "outline-danger btn-cancel danger px-3 mr-2"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onCancel()
                                    }
                                  }
                                },
                                [_vm._v(" Cancelar ")]
                              ),
                              _c(
                                "action-button",
                                {
                                  attrs: {
                                    i: "fas fa-save",
                                    variant: "success px-3"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onSave()
                                    }
                                  }
                                },
                                [_vm._v(" Guardar ")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }